export default "__VITE_ASSET__DS6kSS17__"